import {FC, ReactNode} from 'react'
import styles from './styles.module.scss'

type PayButtonProps = {
  isVisible: boolean
  handler: () => void
  isLoading?: boolean
  backgroundColor?: string
  children: ReactNode
}

export const PayButton: FC<PayButtonProps> = ({isVisible, handler, isLoading, backgroundColor, children})=>{
  if (!isVisible) return <></>

  return (
    <button
      style={{backgroundColor}}
      className={styles.paymentButton}
      onClick={handler}
      disabled={isLoading}
    >
      {children}
    </button>
  )
}